<template>
  <div>
    <div
      v-if="content == null || loading"
      class="media-library-field"
    >
      <div
        v-if="loading"
        class="media-library-field__loader"
      >
        <app-medialibrary-loader />
      </div>
      <div
        v-else-if="content == null"
        class="media-library-field__selector"
      >
        <span
          class="media-library-field__selector__button"
          @click="showManager = true"
        >Attach {{ types.images && types.files ? 'file' : (types.images && !types.files) ? 'image' : 'file' }}</span>

        <p
          v-if="helper"
          class="media-library-field__selector__helper"
          v-html="helper"
        />
      </div>
    </div>
    <template v-else-if="file">
      <v-hover>
        <v-img
          slot-scope="{hover}"
          :src="file.responsiveImages.Large"
          contain
        >
          <v-expand-transition mode="out-in">
            <v-row v-if="hover">
              <v-col
                class="text-right"
                cols="12"
              >
                <v-icon
                  color="black"
                  @click="clear"
                >
                  mdi-close
                </v-icon>
                <v-icon
                  color="black"
                  @click="showManager = true"
                >
                  mdi-pencil
                </v-icon>
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-img>
      </v-hover>
    </template>

    <v-dialog v-model="showManager">
      <vue-medialibrary-manager
        ref="medialibrary"
        :filetypes="filetypes"
        :types="types"
        :selected="value"
        :selectable="true"
        :url="url"
        return-object
        @close="showManager = false"
        @select="insert"
        @fail-to-find="clear"
      />
    </v-dialog>
  </div>
</template>

<script>
    import Loader from './Loader'
    export default {
        name: 'VueMedialibraryField',

        components: {
            'app-medialibrary-loader': Loader
        },

        props: {
            value: {
                type: [Number, String],
                required: false
            },
            types: {
                type: Object,
                required: false,
                default: () => ({
                    images: true,
                    files: true
                })
            },
            url: {
                required: true,
                type: String
            },
            filetypes: {
                type: Array,
                required: false,
                default: () => ([])
            },
            helper: {
                type: String,
                required: false
            }
        },

        data: () => ({
            loading: true,
            showManager: false,
            file: {},
            content: null,
        }),

        watch: {
            value(val) {
                if (val == null) {
                    this.file = {}
                    this.content =null
                    return
                }
                if (typeof this.file.id == 'undefined') {
                    this.loading = true
                }
            }
        },

        mounted() {
            this.content = this.value ? this.value : this.content
            if (this.content == null) {
                this.loading = false
            }
        },

        methods: {
            insert(value) {
                this.loading = false
                this.showManager = false
                if (value) {
                    this.file = value
                } else {
                    this.file = {}
                }
                this.content = value.id
                this.change()
            },
            clear() {
                this.loading = false
                this.content = null
                this.file = {}
                this.$refs.medialibrary.clearSelected('images')
                this.$emit('input', null)
            },
            change() {
                this.$emit('input', this.content)
            },
            getData() {
                if (!this.loading) {
                    return {
                        image_id: this.file ? this.file.id : null
                    }
                } else {
                    return {
                        image_id: this.value ? this.value : null
                    }
                }
            }
        },
    }
</script>
